module.exports = __webpack_public_path__ + "static/media/teachCompany.d99276c0.gif";